import { z } from 'zod';

const nameSchema = z.string();

export const validateName = (value?: string): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = nameSchema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const SizeSchema = (min = 1, max = 60) => {
  return z
    .union([z.string(), z.number()])
    .transform(val => Number(val))
    .refine(val => !isNaN(val), {
      message: 'Must be a number',
    })
    .refine(val => val >= min && val <= max, {
      message: `Must be between ${min} and ${max}`,
    });
};

export const validateSize = (input?: number | string, min = 1, max = 60) => {
  if (input === undefined || input === null || input === '') return false;
  try {
    SizeSchema(min, max).parse(input);
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors?.[0]?.message;
    }
    return 'Invalid Input';
  }
};
